// extracted by mini-css-extract-plugin
module.exports = {"arrow":"slider-navigation_arrow__r2Jes","nav":"slider-navigation_nav__UeDFI","navButton":"slider-navigation_navButton__6oS8i"};